<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.printer && localService.languageContent.seller">
    <div style="max-width: 1200px;" class="center banner">
        <div class="row row_header freeze_height">
            <div>
                <div class="row">
                    <div class="col-md-4" style="text-align: left;">
                        <button class="btn btn-primary" [disabled]="isIncludeInActive || items.length == 0"
                            (click)="onAction(7)" style="margin-left: 20px;margin-right: 10px;">
                            <i class="material-icons" style="color: white;top: 5px;position: relative;">print</i>
                            <span>{{localService.languageContent.printer.test}}</span>
                        </button>
                        <button class="button_icon button_icon_color icon_adjust"
                            *ngIf="businessId != '' && businessId != '0'"
                            title="{{localService.languageContent.seller.font_settings}}"
                            (click)="onActionBusiness(4)">font_download</button>
                        &nbsp;
                        <button class="button_icon button_icon_color icon_adjust"
                            *ngIf="businessId != '' && businessId != '0'"
                            title="{{localService.languageContent.seller.receipt_icon_config}}"
                            (click)="onActionBusiness(5)">image</button>
                        &nbsp;
                        <button class="button_icon button_icon_color icon_adjust"
                            *ngIf="businessId != '' && businessId != '0'"
                            title="{{localService.languageContent.seller.bill_adjust}}"
                            (click)="onActionBusiness(3)">adjust</button>
                        &nbsp;
                        <button class="button_icon button_icon_color icon_adjust"
                            *ngIf="businessId != '' && businessId != '0'"
                            title="{{localService.languageContent.seller.clear_cache}}"
                            (click)="onActionBusiness(2)">settings_backup_restore</button>
                    </div>
                    <div class="col-md-4">
                        <input autocomplete="off" type="text" [(ngModel)]="searchKey"
                            title="{{localService.languageContent.common.search}}"
                            placeholder="{{localService.languageContent.common.search}}" (input)="onFilter()" />
                    </div>
                    <div class="col-md-4" style="text-align: right;">
                        <label style="font-weight: normal;">
                            <input type="checkbox" [(ngModel)]="isIncludeInActive" (change)="onLoad()" />
                            <span>{{localService.languageContent.printer.showDeleted}}</span>
                        </label>
                        <button class="btn btn-primary" (click)="onAction(1)" style="margin-left: 20px;">
                            <i class="material-icons" style="color: white;top: 5px;position: relative;">add</i>
                            <span>{{localService.languageContent.common.add}}</span>
                        </button>

                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8" style="text-align: left;">
                <button class="button_icon button_icon_color icon_adjust" style="border: none;"
                    (click)="onLoad()">refresh</button>
                <span
                    style="position: relative;left: 5px;">{{localService.languageContent.printer.receiptTemplates}}</span>
            </div>
            <div class="col-4" style="text-align: left;">
                <span>{{localService.languageContent.table.created_on}}</span>
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div class="row styled_row" *ngFor="let item of items">
                <div class="col-8">
                    <button class="button_icon button_icon_color" (click)="onAction(2,item.Key)">
                        edit
                    </button>
                    <span>{{item.Title}}</span>
                </div>
                <div class="col-3">
                    <span>{{item.Mandatory.CreatedDate | date : 'dd-MMM-yyyy'}}</span>
                </div>
                <div class="col-1">
                    <button class="button_icon" (click)="onAction(item.Mandatory.IsActive ? 4 : 5,item.Key)"
                        [ngStyle]="{'color' : item.Mandatory.IsActive ? 'red' : 'green'}">
                        {{item.Mandatory.IsActive ? 'delete' : 'restore'}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div>
    <app-print-receipt *ngIf="isTestPrint" [receiptId]="billingId" [isForBusiness]="true"
        (onPrinted)="isTestPrint = false" [businessId]="businessId" [interactionType]="2"></app-print-receipt>
    <app-receipt-template-popup [(isOpenPopup)]="isOpenReceiptTemplatePopup" [businessId]="businessId"
        [ctryCode]="ctryCode" (onClose)="onLoad(true)" [itemId]="selectedItemId" />
    <app-message-box *ngIf="isOpenConfirmationBox" [IsConfirmationType]="true" (onClose)="onDelete($event)"
        [IsPopup]="true" />
    <app-billing-adjust-formula *ngIf="businessId && businessId != '0'" [(isOpen)]="isOpenBillingAdjustmentFormula"
        [businessId]="businessId" [countryCode]="ctryCode" (onClose)="isOpenBillingAdjustmentFormula = false" />
    <app-font-settings-config [(isOpenPopup)]="isOpenFontSettings" [businessId]="businessId" />
    <app-receipt-icon-config [(isOpenPopup)]="isReceiptIconConfig" [businessId]="businessId" />
</div>